module.exports = function getResource(label) {
    const resources = {
        seeMore: 'See more',
        showMore: 'Show more',
        signInButton: 'Sign in to Discover',
        viewPersonalizedRecommendations: 'View personalized recommendations',
        createAnAccount: 'Create an account',
        notABeautyInsider: 'Not a Beauty Insider?',
        blurredRecommendedTitle: 'Recommended for You'
    };
    return resources[label];
};
